export default function formatNumberWithScale(value, scale = null) {
    if (value === '' || value === null || value === undefined || isNaN(value)) {
        return value;
    }

    if (scale === null) {
        return value;
    }

    return Intl.NumberFormat('fr-FR', {
        style: 'decimal',
        minimumFractionDigits: scale,
        maximumFractionDigits: scale,
    }).format(Number.parseFloat(value));
};
